import { useEffect, useState } from 'react';
import { Smartphone, Download, X } from 'lucide-react';

const PUBLIC_URL = 'https://ad-portal-gbrook8344s-team-company.v.monday.app';
const QR = `https://api.qrserver.com/v1/create-qr-code/?size=360x360&margin=10&data=${encodeURIComponent(PUBLIC_URL)}`;

/** Full box on the home screen; a small button once the visitor is using the portal. */
export function PhoneBox({ home }: { home: boolean }) {
  const [open, setOpen] = useState(false);
  useEffect(() => { if (home) setOpen(false); }, [home]);

  if (!home && !open) {
    return (
      <div className="mx-auto mt-10 flex max-w-6xl justify-center px-4 print:hidden">
        <button onClick={() => setOpen(true)} className="inline-flex min-h-11 items-center gap-2 border border-border bg-card px-4 text-xs font-semibold hover:bg-muted">
          <Smartphone className="h-4 w-4 text-primary" />Add this portal to your phone
        </button>
      </div>
    );
  }

  return (
    <section aria-labelledby="phone-box" className="mx-auto mt-10 max-w-6xl px-4 print:hidden">
      <div className="relative flex flex-col gap-4 border-2 border-foreground bg-card p-4 sm:flex-row sm:items-center sm:gap-6 sm:p-5">
        {!home && (
          <button onClick={() => setOpen(false)} aria-label="Close" className="absolute right-1 top-1 inline-flex h-11 w-11 items-center justify-center text-muted-foreground hover:text-foreground">
            <X className="h-4 w-4" />
          </button>
        )}
        <div className="min-w-0 flex-1">
          <h2 id="phone-box" className="flex items-center gap-2 font-[family-name:var(--font-heading)] text-xl font-semibold text-[hsl(var(--brand-blue))]">
            <Smartphone className="h-5 w-5 shrink-0 text-primary" />Add this handy portal to your phone
          </h2>
          <p className="mt-1 text-xs text-muted-foreground">It opens like an app — no download needed.</p>
          <div className="mt-3 grid gap-x-6 gap-y-1 text-sm sm:grid-cols-2">
            <p><strong>iPhone:</strong> in Safari, tap <strong>Share</strong> → <strong>Add to Home Screen</strong></p>
            <p><strong>Android:</strong> in Chrome, tap <strong>⋮</strong> → <strong>Add to Home screen</strong></p>
          </div>
        </div>
        <div className="flex items-center gap-3 border-t border-border pt-3 sm:border-l sm:border-t-0 sm:pl-5 sm:pt-0">
          <img src={QR} alt="QR code that opens the Star-Revue portal" width={96} height={96} className="h-24 w-24 bg-background" />
          <div className="max-w-32 text-xs text-muted-foreground">
            On a computer? Scan with your phone.
            <a href={QR} target="_blank" rel="noreferrer" download="star-revue-qr.png" className="mt-1 inline-flex min-h-9 items-center gap-1 font-semibold text-foreground underline underline-offset-2">
              <Download className="h-3 w-3" />Download
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
